import type { FaireProductEntity } from "../../entity_types/product";

export const p_7eppbpgtqe: FaireProductEntity = {
  token: "p_7eppbpgtqe",
  type: "product",
  name: "GINGHAM DETAIL KNIT SWEATER CARDIGAN",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/de5f2c7edc79c7d66fee104137ece0b0340b05703f8db9219408966b6b4b831d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7fa42963023f14084574c71499c962f2902b17e1291ba6f7fa2199556aaf66b5.jpeg",
    "https://cdn.faire.com/fastly/72b650b78a37ad17e4ced2f4c780139a7a27b0bd5154f3b93ec8006326066a18.jpeg",
    "https://cdn.faire.com/fastly/0ce8378f3239f2af37c9efeab462e377d3ac05a73f160e2066997580933792c3.jpeg",
    "https://cdn.faire.com/fastly/94dbf9f2e8488bc4bbfa0b2fb98d0c84bde72bd0c71cad7ee247d419a8847601.jpeg",
    "https://cdn.faire.com/fastly/8a632089ce23b58eef2ab8d1bd163044d7073264ce8def10f790e8ecae00b8a2.jpeg",
    "https://cdn.faire.com/fastly/f47b208eaad806ae27e3f32f3d05a4f69e27bab1b7700b54213bdcbaa314d38b.jpeg",
    "https://cdn.faire.com/fastly/41c402f98f3c5c383ea8227e843299efc5683692b251111e64c8ed8a7bca7b69.jpeg",
    "https://cdn.faire.com/fastly/a97b5d414d332c72148a33a050f12920e370911bce1456f01df3a023680c8f60.jpeg",
    "https://cdn.faire.com/fastly/49fbf551368d5b76355005743d5d188684c492559899ab85353a1bb2c1043687.jpeg",
    "https://cdn.faire.com/fastly/ae035489ce9789907f0c80f7aaa5ee3beb3b40127d5fb4500016e4799bd18873.jpeg",
    "https://cdn.faire.com/fastly/602a1dce5b526468b5e8572f1b5b0a0032d47fbd892026f0939c13850e57c6f8.jpeg",
    "https://cdn.faire.com/fastly/6009fdbe07dbeb8d2684c2ba386de6c7c8c4a828e6790f7aa5a5ad231b00bf75.jpeg",
    "https://cdn.faire.com/fastly/88b65e70af43beea75e35a721ced42e7a0a0f9538765291256b0fd2184a46613.jpeg",
    "https://cdn.faire.com/fastly/ff35355ded2209204d5a61af4438305596fc8037c1b23a6ee6a48e1a44f1b867.jpeg",
  ],
  priceDollars: 192,
  description:
    '\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32A\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 384,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T17:05:56.180Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
